import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import { validate } from "shared/yup";
import { getCities } from "redux/selector";
import { PropertyType } from "type/property-type";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell, WidgetSelect, WidgetNumber } from "../widget-fields";
import { listingsSchema, DEFAULT_LISTINGS_SORT } from "./validation";
import { getUser } from "redux/selector";
import { ListingSortType } from "type/listing-sort";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
		cities: getCities(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	propertyTypeId: string;
	cityId?: number;
	beds?: number;
	baths?: number;
	minPrice?: number;
	maxPrice?: number;
	status: string;
	sort: string;
	resultsPerPage: number;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			propertyTypeId: "",
			status: "active",
			sort: DEFAULT_LISTINGS_SORT,
			resultsPerPage: 15,
		}
	}

	private validationSchema = listingsSchema;

	public render() {
		const { user, cities } = this.props;
		const { cityId, propertyTypeId, resultsPerPage, sort, status, beds, baths, minPrice, maxPrice } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.listingsWidget(
			user.websitePlatform,
			cityId ? cityId : 0,
			propertyTypeId,
			status,
			sort,
			resultsPerPage,
			beds,
			baths,
			minPrice,
			maxPrice,
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell>
						<WidgetSelect
							label="Property Type"
							required
							value={propertyTypeId}
							options={PropertyType.activeValues().map((value) => ({value: value.id, label: value.label}))}
							onChange={(value) => this.setState({propertyTypeId: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetSelect
							label="City"
							required
							value={cityId}
							options={cities.map((value) => ({value: value.id, label: value.name}))}
							onChange={(value) => this.setState({cityId: parseInt(value)})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetSelect
							label="Listing Status"
							required
							value={status}
							options={[{value: "active", label: "Active"}, {value: "sold", label: "Sold"}]}
							onChange={(value) => this.setState({status: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetSelect
							label="Sort"
							required
							value={sort}
							options={ListingSortType.values().map((value) => ({value: value.id, label: value.label}))}
							onChange={(value) => this.setState({sort: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetNumber
							label="Bedrooms"
							min={1}
							value={beds}
							onChange={(value) => this.setState({beds: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetNumber
							label="Bathrooms"
							min={1}
							value={baths}
							onChange={(value) => this.setState({baths: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetNumber
							label="Min Price"
							startAdornment="$"
							min={1}
							value={minPrice}
							onChange={(value) => this.setState({minPrice: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetNumber
							label="Max Price"
							startAdornment="$"
							min={1}
							value={maxPrice}
							onChange={(value) => this.setState({maxPrice: value})}
						/>
					</WidgetFieldCell>
					<WidgetFieldCell>
						<WidgetNumber
							label="Results Per Page"
							required
							min={1}
							max={50}
							value={resultsPerPage}
							onChange={(value) => this.setState({resultsPerPage: value})}
							helperText={errors && errors.resultsPerPage}
						/>
					</WidgetFieldCell>
				</WidgetFieldGrid>
			</WidgetConfigLayout>			
		);
	}
}

export const ListingsConfig = (
	connect(mapStateToProps, mapDispatchToProps)(Component)
);